module.exports = __webpack_public_path__ + "static/media/img_step_7.42dd6fd2.jpg";